import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {
    Button,
    Typography,
} from '@material-ui/core';
import {Formik, Form} from 'formik';


import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';

import Loading from "../../../../Loading";
import axios from 'axios';

import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import ProgressbarMobile from "../../../../customer/ProductsCustomer/Mobile/ProgressBarMobile";
import motorbike_white_icon from '../../../../../assets/images/white_motorbike_icon.png';

//FORMS
import MotovehiculoForm from "./Forms/MotovehiculoForm";
import TitularForm from "./Forms/TitularForm";
import PolizaForm from "./Forms/PolizaForm";
import ClienteForm from "./Forms/ClienteForm";
import DetallesMotovehiculoForm from "./Forms/DetallesMotovehiculoForm";
import SolicitudForm from "./Forms/SolicitudForm";
import CotizacionSuccess from "./CotizacionSuccess";
import EmisionSuccess from "./EmisionSuccess";

import AffinityContext from "../../../../../context/AffinityContext";
import moment from "moment";
import {formatPhoneNumberIntl} from "react-phone-number-input";

const steps = ['Titular', 'Vehículo', 'Resumen', 'Cliente', 'Póliza', 'Detalles', 'Solicitud'];
const {formId, formField} = formModel;

//Review states: are them all necessary?
function _renderStepContent(step, cotizacionResponse, finalValues, localidades, setCoverageSelectedId, coverageSelectedId, vehicleDetails) {
    switch (step) {
        case 0:
            return <TitularForm formField={formField} localidades={localidades}/>;
        case 1:
            return <MotovehiculoForm
                formField={formField}
                vehicleDetails={vehicleDetails}
            />;
        case 2:
            return <div style={{margin: "16px"}}>
                {(cotizacionResponse !== null && finalValues !== null)
                    ?
                    <CotizacionSuccess finalValues={finalValues}
                                       coverageSelectedId={coverageSelectedId}
                                       setCoverageSelectedId={setCoverageSelectedId}
                                       cotizacionResponse={cotizacionResponse}/>
                    : (
                        <Fragment>
                            <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                                Cotizando. Por favor espere...
                            </Typography>
                            <Loading/>
                        </Fragment>
                    )
                }
            </div>
        case 3:
            return <ClienteForm formField={formField}/>;
        case 4:
            return <PolizaForm formField={formField}/>;
        case 5:
            return <DetallesMotovehiculoForm
                formField={formField}
            />;
        case 6:
            return <SolicitudForm formField={formField}/>;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutPage(props) {
    const {recotizar, idCotizacion, isMobile, scrollIntoView} = props;
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(recotizar === true ? steps.length : 0);
    const currentValidationSchema = validationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [emisionResponse, setEmisionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const [coverageSelectedId, setCoverageSelectedId] = useState(null);

    const [saved, setSaved] = useState(false)
    const {
        localidades,
        affinityId,
    } = useContext(AffinityContext);
    const [localidadesMap, setLocalidadesMap] = useState(null)
    const vehicleDetails = useRef({
        detalle_marca: "",
        detalle_version: ""
    })

    async function _cotizarForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar/motovehiculo';

        values.motovehiculo = {
            ...values.motovehiculo,
            ...vehicleDetails?.current
        }

        let splittedPhone = formatPhoneNumberIntl(values.telefono).split(' ');
        let jsonData = {
            "origen": "affinity",
            "afinidad": parseInt(affinityId),
            "operacionCliente": true,

            //PÓLIZA
            "vigencia": values.vigencia,
            "frecuenciaPago": values.frecuenciaPago,
            "codigosLocalidad": values.codigosLocalidad,
            "ajusteAutomatico": values.ajusteAutomatico,
            "cuotas": values.cuotas,

            //CLIENTE
            "situacionImpositiva": values.situacionImpositiva,
            "tipoPersona": values.personaJuridica,
            "cliente": {
                "nombre": values.nombre,
                "apellido": values.apellido,
                "dni": values.dni,
                "email": values.email,
                "codArea": splittedPhone[1],
                "telefono": `${splittedPhone[2]}${splittedPhone[3]}`,
            },
            "motovehiculo": {
                ...(saved ? {} : { sumaAsegurada: 0 }),
                ...values.motovehiculo,
                "patente": values.motovehiculo.patente.toUpperCase(),
            }
        }

        setFinalValues(values);

        let data = saved ?
            {
                saveToDatabase: true,
                idCotizar: cotizacionResponse['cotizacionId'],
                is_saved: saved,
                modeloCodigo: values.modelo
            } : {saveToDatabase: true}


        axios.post(url, {...jsonData, ...data},).then(res => {
            setCotizacionResponse({
                ...res.data,
                "plans": res.data.plans.filter(plan => plan.outStandard === "false")
            });
            setSaved(true)
        }).catch(err => {
            console.log(err);
        });
        actions.setSubmitting(false);
    }

    async function _emitirForm(values, actions) {

        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/motovehiculo';

        let splittedPhone = formatPhoneNumberIntl(values.telefono).split(' ');
        let jsonData = {
            "origen": "affinity",
            "afinidad": affinityId,
            "operacionCliente": true,
            "bienesAsegurados": values.bienesAsegurados,

            //VEHICULO
            "motovehiculo": {
                ...values.motovehiculo,
                "patente": values.motovehiculo.patente.toUpperCase(),
            },


            //PÓLIZA
            "premium": values.premium,
            "outStandard": values.outStandard,
            "vigencia": values.vigencia,
            "moduloCobertura": values.moduloCobertura,
            "nombreCobertura": values.nombreCobertura,
            "frecuenciaPago": values.frecuenciaPago,
            "codigosLocalidad": values.codigosLocalidad,
            "comentariosSolicitud": values.comentariosSolicitud,
            "cuotas": values.cuotas,
            "despachoElectronico": values.despachoElectronico,
            "emailDespachoElectronico": values.emailDespachoElectronico,
            "formaDePago": values.formaDePago,
            "idCotizacion": cotizacionResponse.cotizacionId,
            "infoDePago": {
                ...values.infoDePago
            },

            //CLIENTE
            "clientes": [{
                "nombre": values.nombre,
                "apellido": values.apellido,
                "dni": values.dni,
                "email": values.email,
                "codigoArea": splittedPhone[1],
                "telefono": `${splittedPhone[2]}${splittedPhone[3]}`,
                "situacionIva": values.situacionImpositiva,
                "personaJuridica": values.personaJuridica,
                "codigosLocalidad": values.codigosLocalidad,
                "actividadPrincipal": values.actividadPrincipal,
                "categoriaMonotributo": values.categoriaMonotributo,
                "cuit": values.cuit,
                "domicilio": values.domicilio,
                "estadoCivil": values.estadoCivil,
                "fechaNacimiento": moment(values.fechaNacimiento, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                "lugarNacimiento": values.lugarNacimiento,
                "rol": values.rol,
                "sexo": values.sexo,
            }],


            "vigenciaHasta": moment(values.vigenciaHasta, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            "vigenciaDesde": moment(values.vigenciaDesde, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        }

        setFinalValues(jsonData);

        axios.post(url, {...jsonData, idCotizacion: cotizacionResponse.cotizacionId}).then(res => {
            console.log(res.data)
            const data = res.data;
            if (data.officialNumber && typeof data.officialNumber === 'object') {
                data.officialNumber = null;
            }
            setEmisionResponse(data)
            actions.setSubmitting(false);
        }).catch(err => {
            console.log(err);
            alert('No se pudo completar la operación, vuelva a cargar la página')
        });

    }

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        scrollIntoView()
        if (activeStep === 6) {
            setActiveStep(activeStep + 1);
            _emitirForm(values, actions)
        } else if (activeStep === 1) {
            setActiveStep(activeStep + 1);
            setCotizacionResponse(null)
            _cotizarForm(values, actions);
        } else {
            actions.setTouched({});
            actions.setSubmitting(false);
            setActiveStep(activeStep + 1);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    const componentToShow = (actStep) => {
        let component;
        if (actStep === 7) {
            component = (
                <Fragment>
                    <div style={{margin: "16px"}}>
                        {(emisionResponse !== null && finalValues !== null)
                            ? <EmisionSuccess finalValues={finalValues} emisionResponse={emisionResponse}
                                              idCotizacion={idCotizacion} setActiveStep={setActiveStep}
                                              setEmisionResponse={setEmisionResponse}/>
                            : (
                                <Fragment>
                                    <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                                        Procesando el pedido. Por favor espere...
                                    </Typography>
                                    <Loading/>
                                    <Typography variant="body1" gutterBottom align="center">
                                        Esto puede demorar hasta 60 segundos.
                                    </Typography>
                                </Fragment>
                            )
                        }
                    </div>
                </Fragment>
            )
        }

        return component;
    }

    useEffect(() => {
        let options = localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidadesMap(options);
    }, [localidades])


    return (
        <React.Fragment>
            {localidadesMap ?
                <>
                    <div className={isMobile ? classes.formBoxMobile : classes.formBox}>

                        <div className={classes.iconCircle}>
                            <img src={motorbike_white_icon} style={{width: "40px", height: "auto"}}/>
                        </div>
                        <div style={{margin: "16px 0px"}}>
                            {isMobile
                                ? <ProgressbarMobile activeStep={activeStep} stepTitles={steps}/>
                                : <ProgressBar activeStep={activeStep} stepTitles={steps}/>}
                        </div>
                        <Fragment>

                            <Formik
                                initialValues={formInitialValues}
                                validationSchema={currentValidationSchema}
                                validateOnBlur={false}
                                onSubmit={_handleSubmit}
                            >
                                {({isSubmitting}) => (
                                    <Form id={formId}>
                                        {componentToShow(activeStep)}
                                        <div style={{
                                            display: activeStep === 7 ? "none" : "block"
                                        }}>
                                            {_renderStepContent(activeStep, cotizacionResponse, finalValues, localidadesMap, setCoverageSelectedId, coverageSelectedId, vehicleDetails)}
                                        </div>
                                        <div className={classes.buttons} style={{display: activeStep > 6 && "none"}}>
                                            {activeStep !== 0 && (
                                                <div className={classes.buttons}>
                                                    <Button
                                                        onClick={_handleBack}
                                                        variant="contained"
                                                        className={classes.backButton}
                                                        disabled={isSubmitting}
                                                    >
                                                        Atras
                                                    </Button>
                                                </div>
                                            )}
                                            <div className={classes.buttons}
                                                 style={{display: activeStep > 6 && "none"}}>
                                                <Button
                                                    disabled={
                                                        (activeStep === 2 && coverageSelectedId === null) || isSubmitting
                                                    }
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.buttonContained}
                                                >
                                                    {isLastStep
                                                        ? 'Emitir'
                                                        : activeStep === 1
                                                            ? 'Cotizar'
                                                            : 'Siguiente'}
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>

                        </Fragment>
                    </div>
                </>
                :
                <Loading/>}

        </React.Fragment>
    );
}
